import type { EmailMxResult } from '@sifly/shared-utils'

type Props = {
  mx: EmailMxResult
  onPick?: (suggestion: string) => void
  className?: string
}

/**
 * Inline email-validation annotation. Shown just below an email input
 * (portal InlineText, QuoteBuilder email, storefront ContactForm, etc.).
 * Null MX → renders nothing; invalid domain → amber warning; valid with
 * typo-suggestion → soft blue "did you mean".
 */
export default function MxHint({ mx, onPick, className }: Props) {
  if (!mx) return null

  if (!mx.valid) {
    return (
      <p className={`text-xs text-[var(--color-warning-strong)] mt-0.5 ${className ?? ''}`}>
        No mail server found for this domain
        {mx.suggestion && (
          <>
            {' — did you mean '}
            <button
              type="button"
              className="underline text-[var(--color-info-strong)] hover:opacity-80"
              onClick={() => onPick?.(mx.suggestion!)}
            >
              {mx.suggestion}
            </button>?
          </>
        )}
      </p>
    )
  }

  if (mx.suggestion) {
    return (
      <p className={`text-xs text-[var(--color-info-strong)] mt-0.5 ${className ?? ''}`}>
        Did you mean{' '}
        <button
          type="button"
          className="underline hover:opacity-80"
          onClick={() => onPick?.(mx.suggestion!)}
        >
          {mx.suggestion}
        </button>?
      </p>
    )
  }

  return null
}
